import React from 'react';
import { RiBarcodeLine, RiArrowRightLine } from 'react-icons/ri';
import * as yup from 'yup';
import { useFormik } from 'formik';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import { FormInput } from '@omnigenbiodata/ui';
import { MESSAGES } from '../../../../../../core/constants/forms.constants';
import { REGEX_PRIMARY_OR_ALIQUOT } from '../../../../../../core/validation/aliquots.validation';

interface BatchSearchValues {
  searchTerm: string;
}

interface BatchSearchProps {
  onSearch: (values: BatchSearchValues) => void;
  buttonLabel?: string;
  searchTerm?: string;
  showTitle?: boolean;
  stack?: boolean;
}

function BatchSearch({ searchTerm = '', buttonLabel = 'Search', onSearch, stack = false }: BatchSearchProps) {
  const validationSchema = yup.object({
    searchTerm: yup
      .string()
      .required(MESSAGES.sampleSearchTermRequired)
      .matches(REGEX_PRIMARY_OR_ALIQUOT, 'Invalid barcode'),
  });

  const formik = useFormik<BatchSearchValues>({
    enableReinitialize: true,
    initialValues: {
      searchTerm,
    },
    validateOnMount: true,
    validationSchema,
    onSubmit: (values) => {
      onSearch(values);
    },
  });

  return (
    <Box data-testid="batchSearch">
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} md={stack ? 12 : 10}>
            <FormInput
              label="Primary ID / Aliquot ID"
              type="text"
              name="searchTerm"
              error={formik.errors.searchTerm}
              touched={formik.touched.searchTerm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.searchTerm}
              margin="none"
              startAdornment={<RiBarcodeLine />}
            />
          </Grid>

          <Grid item xs={12} md={stack ? 12 : 2}>
            <Box
              sx={{
                pt: { xs: 0, md: 0 },
              }}
            >
              <Button
                type="submit"
                variant="contained"
                size="large"
                color="primary"
                fullWidth
                endIcon={<RiArrowRightLine />}
                sx={{ height: '55px !important', m: '0 !important' }}
              >
                {buttonLabel}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default BatchSearch;
